import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import { VendorInformationChangeRequestService } from '../../service/vendor-information-change-request.service';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { UserService } from '../../service/user.service';
import { Login } from '../../models/LoginView';

@Component({
  selector: 'app-vendor-singup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './vendor-singup.component.html',
  styleUrl: './vendor-singup.component.css',
})
export class VendorSingupComponent implements OnInit {
  submitted: boolean = false;
  idForm: FormGroup;
  form: FormGroup;
  passwordMismatch: boolean = false;
  isPasswordVisible: boolean = false;
  isVendorIdStep: boolean = true;
  isPreApprovalSignup: boolean = false;
  prefixLabel: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private VendorInformationChangeRequestService: VendorInformationChangeRequestService,
    private userloginservice: UserService,
    private loadingService: LoadingService,
  ) {
    this.idForm = this.formBuilder.group({
      vendorId: [null, Validators.required],
    });
    this.form = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      VendorId: ['00000000-0000-0000-0000-000000000000'],
      Email: [null, [Validators.email, Validators.required]],
      Password: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>`~_=\\/";:[]+]*$',
          ),
        ],
      ],
      ConfirmPassword: [null, Validators.required],
    });
  }
  ngOnInit() {
    const pendingFormId = this.route.snapshot.queryParamMap.get('vendorFormId');
    if (pendingFormId) {
      // Pre-approval signup straight after registration: the vendor form already
      // exists (pending approval), so skip the vendor-number lookup step.
      this.isPreApprovalSignup = true;
      this.isVendorIdStep = false;
      this.form.get('VendorId')!.setValue(pendingFormId);
      return;
    }

    const vendorid = JSON.parse(
      localStorage.getItem('registrationData') || '{}',
    );

    if (vendorid) {
      this.setupForm(vendorid);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.idForm.invalid) {
      this.utilityService.getFormValidationErrors(this.idForm);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }

    let request = _.cloneDeep(this.idForm.value);
    localStorage.setItem('vendorNumber', JSON.stringify(request.vendorId));
    let requestCall;
    this.loadingService.OnLoading.emit(true);
    requestCall =
      this.VendorInformationChangeRequestService.getVendorInformation(
        request.vendorId,
      );
    requestCall.subscribe(
      (data: any) => {
        this.loadingService.OnLoading.emit(false);
        localStorage.setItem('vendorId', JSON.stringify(data.id));
        localStorage.setItem('registrationData', JSON.stringify(data));
        this.form.get('VendorId')!.setValue(data.id);

        if (
          data.confirmation ===
          'There is some issue in saving, please try again later!'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Incorrect vendor id please enter correct vendor id',
          });
        } else {
          this.isVendorIdStep = false;
        }
      },
      (err: any) => {
        this.loadingService.OnLoading.emit(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Incorrect vendor id please enter correct vendor id.',
        });
        this.notificationService.showError(err, 'Error');
      },
    );
  }
  toggleVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  private setupForm(data: Login) {
    this.loadingService.OnLoading.emit(false);
    this.form.get('VendorId')!.setValue(data.id);
  }
  onsignup() {
    this.submitted = true;
    if (this.form.value.Password !== this.form.value.ConfirmPassword) {
      this.passwordMismatch = true;
    } else {
      this.passwordMismatch = false;

      if (this.form.invalid) {
        this.utilityService.getFormValidationErrors(this.form);
        this.notificationService.showError('Fill all required fields', 'Error');
        return;
      }

      let request = _.cloneDeep(this.form.value);
      let requestCall;
      this.loadingService.OnLoading.emit(true);

      requestCall = this.userloginservice.singup(request, this.prefixLabel);
      requestCall.subscribe(
        (data: any) => {
          this.loadingService.OnLoading.emit(false);
          if (
            data.confirmation ===
            'this email already exists against the same vendor'
          ) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'This email already exists against the same vendor',
            });
          } else if (
            data.confirmation ===
            'this email already exists against the different vendor'
          ) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'This email already exists for a different vendor',
            });
          } else {
            localStorage.setItem(
              'userEmail',
              JSON.stringify(this.form.get('Email')?.value),
            );
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Profile setup successful',
            });
            this.router.navigateByUrl('login');
          }
        },
        (err: any) => {
          this.loadingService.OnLoading.emit(false);
          console.error('Form submission error:', err);
          this.notificationService.showError(err, 'Error');
        },
      );
    }
  }
  get f() {
    return this.isVendorIdStep ? this.idForm.controls : this.form.controls;
  }

  get idf() {
    return this.idForm.controls;
  }
}
